module.exports = __webpack_public_path__ + "static/media/norway.d1bb2f4e.png";